import { render, staticRenderFns } from "./PrintOrderDetailTable.vue?vue&type=template&id=59a5f710&"
import script from "./PrintOrderDetailTable.vue?vue&type=script&lang=ts&"
export * from "./PrintOrderDetailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports